export const boardAddTaskTour = {
  key: "boardAddTask",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-addtask-title"]',
      content: t("Tour_BoardAddTask_Title"),
      placement: "top",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-addtask-description"]',
      content: t("Tour_BoardAddTask_Description"),
      placement: "top",
    },
    {
      target: '[data-tour="board-addtask-column"]',
      content: t("Tour_BoardAddTask_Column"),
      placement: "right",
    },
    {
      target: '[data-tour="board-addtask-members"]',
      content: t("Tour_BoardAddTask_Members"),
      placement: "right",
    },
    {
      target: '[data-tour="board-addtask-date"]',
      content: t("Tour_BoardAddTask_Date"),
      placement: "right",
    },
    {
      target: '[data-tour="board-addtask-priority"]',
      content: t("Tour_BoardAddTask_Priority"),
      placement: "right",
    },
    {
      target: '[data-tour="board-addtask-dependencies"]',
      content: t("Tour_BoardAddTask_Dependencies"),
      placement: "right",
    },
    {
      target: '[data-tour="board-addtask-sprint"]',
      content: t("Tour_BoardAddTask_Sprint"),
      placement: "right",
    },
  ],
};
